import React from 'react';
import classNames from 'classnames';
import styled from 'styled-components/macro';

export interface LegendVoiceProps {
  style?: any;
  className?: string;
  title: any;
  voice: any;
  caption?: any;
  src: string;
}

export function LegendVoice(props: LegendVoiceProps) {
  return (
    <Root style={props.style} className={classNames('legend-voice columns is-tablet', props.className)}>
      <div className="column is-4">
        <figure
          className="is-padding-10px has-background-white"
          style={{ maxWidth: 300, maxHeight: 300, margin: '0 auto' }}
        >
          <img className="" src={props.src} />
        </figure>
      </div>
      <div className="column is-8 is-narrow">
        {props.caption}
        <h2 className="title is-4">{props.title}</h2>
        <div className="content">{props.voice}</div>
      </div>
    </Root>
  );
}

const Root = styled.div`
    padding: 1rem;
`;
